// Simple variant info table handler
document.addEventListener('DOMContentLoaded', function() {
  // Find all product forms
  const productForms = document.querySelectorAll('.js-product-form');
  
  productForms.forEach(form => {
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    // Create observer to watch for value changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          updateVariantTables(variantInput.value);
        }
      });
    });
    
    // Start observing
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    
    // Also listen for input events
    variantInput.addEventListener('input', function() {
      updateVariantTables(this.value);
    });
  });
  
  function updateVariantTables(variantId) {
    // Remove active class from all tables
    document.querySelectorAll('.variant-info-table').forEach(table => {
      table.classList.remove('active');
    });
    
    // Add active class to matching table
    const matchingTable = document.getElementById(variantId);
    if (matchingTable && matchingTable.classList.contains('variant-info-table')) {
      matchingTable.classList.add('active');
    }
  }
}); 